<!--  -->
<template>
  <div class="order-good">
    <div class="store-name">
      <span>{{ info.entityName }}</span>
      <span>{{ info.entityEnName }}</span>
    </div>
    <el-table :data="goodsVOList">
      <el-table-column prop="name" label="商品 Commodities" align="center">
        <template slot-scope="{ row }">
          <div class="good-info">
            <div class="cover-img">
              <el-image :src="row.coverImage"></el-image>
            </div>
            <div class="good-content">
              <p class="primary-text sl-ellipsis">{{ row.name }}</p>
              <p class="primary-text sl-ellipsis">{{ row.nameEn }}</p>
              <div class="good-spec">规格：{{ row.spec || "单规格" }}</div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="payAmount" label="售价 Selling Price" align="center">
        <template slot-scope="{ row }">
          <span>￥</span>
          <span>{{ row.price }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="qty" label="数量 Quantity" align="center"> </el-table-column>
      <el-table-column label="操作 Operation" align="center">
        <template slot-scope="{ row }">
          <el-button v-if="row.orderGoodsStatus == 3" type="primary" @click="checkCode(row.detailVOList)"
            >提货码</el-button
          >
          <el-button v-if="row.showCanRefund" type="primary" @click="refundHandler(row)">申请退款</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    info: {
      type: Object,
      default: () => {},
    },
    orderInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      goodsVOList: [],
    };
  },
  mounted() {},
  methods: {
    handleGoodsVOList(val) {
      if (!val) return;
      let goodsVOList = val.goodsVOList || [];
      let now = new Date().getTime();
      let day = 60 * 60 * 24 * 1000;
      let timeBool = true;
      if (val.orderStoreVO && val.orderStoreVO.finishTime) {
        let finishTime = val.orderStoreVO.finishTime.replace(/\-/g, "/");
        let isTakeout = this.orderInfo.orderType == 3; //是外卖
        finishTime = new Date(finishTime).getTime();
        if (isTakeout) {
          timeBool = now - (finishTime + day) < 0;
        } else {
          timeBool = now - (finishTime + 7 * day) < 0;
        }
      }
      goodsVOList = goodsVOList.map((item) => {
        item.showCanRefund =
          (item.orderGoodsStatus == 3 || item.orderGoodsStatus == 4) && item.refundQtyRest > 0 && timeBool;
        return item;
      });
      this.goodsVOList = goodsVOList;
    },
    checkCode(detailVOList) {
      this.$emit("checkCode", detailVOList);
    },
    refundHandler(item) {
      this.$emit("refundHandler", item);
    },
  },
  watch: {
    info: {
      handler(val) {
        this.handleGoodsVOList(val);
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.order-good {
  .store-name {
    margin-top: 18px;
    margin-bottom: 18px;
  }
  .good-info {
    display: flex;
    .cover-img {
      flex: none;
      .el-image {
        width: 88px;
        height: 88px;
      }
    }
  }
  .good-content {
    padding-left: 20px;
    text-align: left;
    overflow: hidden;
    p {
      line-height: 1.2;
    }
    .good-spec {
      font-size: 14px;
      color: #999999;
      margin-top: 10px;
    }
  }
}
</style>
